import React from 'react'
import { CommunicationMethodSelector } from '@/components/composed/financing/CommunicationMethodSelector'
import { FundingBannerFormWrapper } from '../FundingBannerFormWrapper'
import { messages } from './messages'
import type { TFundingBannerCommunicationMethodSelectorProps } from './types'
import './styles.scss'

export const FundingBannerCommunicationMethodSelector = ({
  fundingRequestId,
  onSuccessUpdateFundingRequest,
  onErrorUpdateFundingRequest,
}: TFundingBannerCommunicationMethodSelectorProps) => {
  return (
    <FundingBannerFormWrapper className="fundingBannerCommunicationMethodSelector">
      <CommunicationMethodSelector
        className="fundingBannerCommunicationMethodSelector__selector"
        cardClassName="fundingBannerCommunicationMethodSelector__method"
        buttonClassName="fundingBannerCommunicationMethodSelector__button"
        title={messages.title}
        fundingRequestId={fundingRequestId}
        onSuccessUpdateFundingRequest={onSuccessUpdateFundingRequest}
        onErrorUpdateFundingRequest={onErrorUpdateFundingRequest}
      />
    </FundingBannerFormWrapper>
  )
}
